import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import b from 'b_';
import SnackStore from '../../stores/SnackStore';
import Page from '../Fuse/Page';
import ConsoleSamlAccessStore from '../../stores/ConsoleSamlAccessStore/ConsoleSamlAccessStore';
import { Card } from '../Fuse';
import { FTBody } from '../Fuse/Text';
import UDSpinner from '../UD/Fragments/UDSpinner';
import ConsoleStore from '../../stores/ConsoleStore';
import SAMLAccess from '../SAMLAccess/SAMLAccess';
import { ROLE_READ_ONLY } from '../../stores/Administrators/AdministratorModalStore';
import './ConsoleSamlAccess.css';

const block = b.lock('ConsoleSamlAccess');

const SSO_CONFIGURATION_LINK = '/console/product_settings/saml_sso_configuration';

class ConsoleSamlAccess extends Component {
    static propTypes = {
        consoleSamlAccess: ConsoleSamlAccessStore.PropType.isRequired,
        console: ConsoleStore.PropType.isRequired,
        snack: SnackStore.PropType.isRequired,
    };


    componentWillMount() {
        this.loadData(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.consoleSamlAccess !== this.props.consoleSamlAccess) {
            this.loadData(nextProps);
        }
    }

    loadData = (props) => {
        if (!this.props.console.isSSOConfigured) {
            props.consoleSamlAccess.setSamlSSODisabled();
            return;
        }
        props.consoleSamlAccess.loadConfigurations()
            .catch((error) => this.props.snack.showError(`Failed to load saml-sso configurations ${error.message}`));
    };

    renderPageContent = () => {
        const { consoleSamlAccess, console } = this.props;
        const { roleAccess, userAccess, samlSSOEnabled } = consoleSamlAccess;

        return samlSSOEnabled.isTrue ? (
            <SAMLAccess
                currentUserId={console.userId}
                roleAccess={roleAccess}
                userAccess={userAccess}
                readOnly={console.authority === ROLE_READ_ONLY.value}
            />
        ) : (
            <Card title="SAML Is Not Enabled">
                <FTBody>
                    {'Proofpoint Isolation can use SAML protocol to authenticate against your organization’s ' +
                    'IdP. If you’d like to set up your Isolation service to use SAML/SSO access, please go to '}
                    <b>Product Settings</b>
                    <a className={block('ConfigureLink')} href={SSO_CONFIGURATION_LINK}> - SAML/SSO Configuration</a>
                </FTBody>
            </Card>
        );
    };

    render() {
        const { consoleSamlAccess } = this.props;

        return <Fragment>
            <Page title="Administrators - SAML/SSO Access">
                {consoleSamlAccess.configStatus.isLoading ? (
                    <UDSpinner type={'fuse'} className={block('Loader')} />
                ) : this.renderPageContent()}
            </Page>
        </Fragment>;
    }
}

export default inject('snack', 'consoleSamlAccess', 'console')(observer(ConsoleSamlAccess));
